<template>
  <div >
    <div class="md-content text-center">
        <div class="md-header"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
       
    }
  },
  created: function () {
    

    
    
  },
  methods: {
    

    
  },
  components: {
  },
  computed: {
   
  },
  watch: {
     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
